import type { PointerEvent } from "react";

import { MatchCard } from "@/features/matches";
import { cn } from "@/shared/lib";
import { Popover, PopoverContent, PopoverTrigger } from "@/shared/ui/popover";

type RankPointProps = {
  matchId: number;
  won: boolean;
  // Подпись для экранного диктора: дата, исход, ранг.
  label: string;
  // Положение в долях области графика.
  x: number;
  y: number;
  open: boolean;
  // Открыто наведением мыши: фокус остаётся на точке, окно закрывается, когда мышь уходит.
  openedByHover: boolean;
  onHover: (hovering: boolean) => void;
  onOpenChange: (open: boolean) => void;
};

const percent = (share: number) => `${String(share * 100)}%`;
const isMouse = (event: PointerEvent) => event.pointerType === "mouse";

// Точка матча на «Пути по рангам»: кнопка с цветом исхода. Наведение, нажатие или Enter
// открывают карточку матча (`MatchCard`) с переходом к разбору или запуском разбора.
export const RankPoint = ({
  matchId,
  won,
  label,
  x,
  y,
  open,
  openedByHover,
  onHover,
  onOpenChange,
}: RankPointProps) => (
  <Popover open={open} onOpenChange={onOpenChange}>
    <PopoverTrigger asChild>
      <button
        type="button"
        aria-label={label}
        data-match-id={matchId}
        onPointerEnter={(event) => {
          if (isMouse(event)) {
            onHover(true);
          }
        }}
        onPointerLeave={(event) => {
          if (isMouse(event)) {
            onHover(false);
          }
        }}
        onClick={(event) => {
          // Уже открыто наведением — нажатие его не закрывает.
          if (open) {
            event.preventDefault();
          }
        }}
        className="group absolute flex size-7 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full outline-none focus-visible:ring-2 focus-visible:ring-accent/60"
        style={{ left: percent(x), top: percent(y) }}
      >
        <span
          className={cn(
            "size-3 rounded-full border-2 border-surface transition-transform group-hover:scale-125",
            won ? "bg-good" : "bg-bad",
            open && "scale-150 group-hover:scale-150",
          )}
        />
      </button>
    </PopoverTrigger>
    <PopoverContent
      side="top"
      align="center"
      className="w-[320px]"
      onOpenAutoFocus={(event) => {
        if (openedByHover) {
          event.preventDefault();
        }
      }}
      onPointerEnter={(event) => {
        if (isMouse(event)) {
          onHover(true);
        }
      }}
      onPointerLeave={(event) => {
        if (isMouse(event)) {
          onHover(false);
        }
      }}
    >
      <MatchCard matchId={matchId} />
    </PopoverContent>
  </Popover>
);
